export default __webpack_public_path__ + "static/media/unicef-worlds-water-day.4ca193c8.webp";